import React from "react";
import { StyleSheet, View } from "react-native";

const Index = () => {
  return (
    <View style={styles.closequotes}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="48"
        viewBox="0 0 55 48"
      >
        <g fill="none" fill-rule="evenodd">
          <g style={{ fill: "var(--module-color-atr)" }} fill-rule="nonzero">
            <path
              d="M79 268v17.348l-.002.57c-.144 18.72-7.407 28.747-21.79 30.082v-8.635l.294-.094c5.252-1.736 7.878-6.346 7.878-13.832v-2.411h-8.172V268H79zm-33.208 0v17.348l-.002.57C45.646 304.638 38.383 314.665 24 316v-8.635l.294-.094c5.252-1.736 7.878-6.346 7.878-13.832v-2.411H24V268h21.792z"
              transform="translate(-48 -454) translate(24 186)"
            />
          </g>
        </g>
      </svg>
    </View>
  );
};

export default Index;

const styles = StyleSheet.create({
  closequotes: {
    height: 46.5,
    width: 55,
    bottom: 10.5,
    left: 19,
  },
});
